module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ul', {
    staticClass: "captures"
  }, [_c('li', [_vm._v("Black: " + _vm._s(_vm.black))]), _vm._v(" "), _c('li', [_vm._v("White: " + _vm._s(_vm.white))])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7e70cda0"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/game/Captures.vue
// module id = 423
// module chunks = 1